import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {SComponent} from "../header/header.component";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent extends SComponent {

  constructor() {
    super();
  }


}



// WEBPACK FOOTER //
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/pages/footer/footer.component.ts